import { render, staticRenderFns } from "./IKHistoricoRelatorio.vue?vue&type=template&id=4a04ff74&scoped=true&"
import script from "./IKHistoricoRelatorio.vue?vue&type=script&lang=js&"
export * from "./IKHistoricoRelatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a04ff74",
  null
  
)

export default component.exports